// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsShare = {
  share: {
    title: "アセット共有",
    notice:
      "共有設定はアセットのメタデータ編集と分離し、正式な shared-resource モデルへ直接収束します。",
    publicDescription: "公開アセットは既定で閲覧・参照・複製を許可します。",
    selectedUsersTitle: "選択済みユーザー",
    emptyUsers: "ユーザーが選択されていません",
    actions: {
      pickUsers: "ユーザーを選択",
    },
    fields: {
      capabilities: "能力",
    },
    capabilities: {
      view: "閲覧",
      reference: "参照",
      clone: "複製",
    },
    errors: {
      requiredShareMode: "共有方式を選択してください",
      selectAtLeastOneUser: "少なくとも 1 人のユーザーを選択してください",
      selectCapabilities: "少なくとも 1 つの能力を選択してください",
    },
    messages: {
      saveSuccess: "アセット共有を保存しました",
      saveFailed: "アセット共有の保存に失敗しました",
    },
  },
} as const;
